import React from 'react';

import {PremiumFeature} from '../../types';
import {Icon, Text} from '../../components';
import {colors} from '../../theme';

export const PremiumFeatures = ({features}: {features: PremiumFeature[]}) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row items-center my-2 gap-2">
        <div className="flex flex-1">
          <Text as="p" variant="LargeBodyBold">
            What&apos;s included
          </Text>
        </div>

        <div className="w-16 flex flex-col items-center text-center">
          <Text as="span" variant="SmallBodyBold">
            Premium
          </Text>
        </div>

        <div className="w-16 flex flex-col items-center text-center">
          <Text as="span" variant="SmallBodyBold">
            Free
          </Text>
        </div>
      </div>

      {features.map(f => {
        return (
          <div key={f.title} className="flex flex-row items-center my-2 ">
            <div className="flex flex-1">
              <Text as="p" variant="LargeBody">
                {f.title}
              </Text>
            </div>

            <div className="w-16 flex flex-col items-center text-center ml-4">
              {f.includedInPremiumTier && (
                <>
                  {f.premiumTierSpecifics ? (
                    <Text
                      as="div"
                      variant="Caption"
                      className="bg-bluerice px-2 py-1 rounded-full">
                      {f.premiumTierSpecifics}
                    </Text>
                  ) : (
                    <Icon
                      iconName="tick-circle"
                      color={colors.black}
                      fill={colors.bluerice}
                      width={24}
                      height={24}
                    />
                  )}
                </>
              )}
            </div>

            <div className="w-16 flex flex-col items-center text-center ml-2">
              {f.includedInFreeTier && (
                <>
                  {f.freeTierSpecifics ? (
                    <Text as="span" variant="Caption">
                      {f.freeTierSpecifics}
                    </Text>
                  ) : (
                    <Icon
                      iconName="tick-circle"
                      color={colors.black}
                      fill={'#fff'}
                      width={24}
                      height={24}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
